import React from "react";
import { Link } from "react-router-dom";
import InputComp from "../../SubComp/InputComp/InputComp";
import "./EditProfile.css";

const EditProfile = () => {
  return (
    <div className="text-white edit-input">

      <h3 className="mb-5">Basic Information</h3>

      <div className="row">

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Name</label>
            </div>
            <div class="col-sm-7">
              <input type='text' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Email</label>
            </div>
            <div class="col-sm-7">
              <input type='email' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Contact</label>
            </div>
            <div class="col-sm-7">
              <input type='text' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Country</label>
            </div>
            <div class="col-sm-7">
              <select class="form-select form-select-lg " aria-label=".form-select-lg example">
                <option selected>Country</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">City</label>
            </div>
            <div class="col-sm-7">
              <select class="form-select form-select-lg" aria-label=".form-select-lg example">
                <option selected>City</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">State</label>
            </div>
            <div class="col-sm-7">
              <select class="form-select form-select-lg " aria-label=".form-select-lg example">
                <option selected>State</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Road No</label>
            </div>
            <div class="col-sm-7">
              <input type='text' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Block</label>
            </div>
            <div class="col-sm-7">
              <input type='text' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-3">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
              <label for="inputPassword6" class="col-form-label">Postal Code</label>
            </div>
            <div class="col-sm-7">
              <input type='text' class=" form-control form-control-lg" placeholder='Type Here' />
            </div>
          </div>
        </div>



        <div className="col-lg-4 mb-3 mt-5">
          <div class="mb-3 row align-items-center edit-input ">
            <div class="col-sm-4 pe-0">
            </div>
            <div class="col-sm-7">
              <Link to="/myprofile">
                <button type="button" className="contact-button " >
                  Save
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default EditProfile;
